import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http/http.service';

@Injectable()
export class FeatureFlagService {
    constructor(
        private httpService: HttpService
    ){}

    public get():Observable<any>{
      return this.httpService.get(`/assets/data/feature-flag.json`);
    }
}
